import { Languages, Translations } from '../type'

export const aboutUsTranslations: Record<Languages, Translations> = {
    fa: {
        general: {
            showMore: 'مشاهده بیشتر',
            showLess: 'مشاهده کمتر',
        },
        story: {
            title: 'داستان خانومی',
            item1: '«خانومی» امروز با بیش از ۳ میلیون کاربر و ۱/۵ میلیون دنبال‌کننده در شبکه‌های اجتماعی که نزدیک به ۲ میلیون نفر از آن‌ها دست‌کم یک بار از «خانومی» خرید کرده‌اند، دیگر فقط اولین و بزرگ‌ترین فروشگاه اینترنتی تخصصی محصولات زیبایی ایران نیست، بلکه بزرگ‌ترین کسب‌وکار آنلاینی است که در حوزه بازار زنان کار می‌کند و به سوی رویای شکل‌گیری بزرگ‌ترین بازار تخصصی خدمات و محصولات زنان ایران قدم برمی‌دارد.',
            item2: '«خانومی» امروز با ارائه بیش از ۵۰ هزار محصول متنوع از بیش از ۱۰۰۰ برند معتبر، نه تنها یکی از منابع اصلی زنان ایرانی برای خرید محصولات مراقبت از خود است بلکه با تمرکز بر توسعه تجارت الکترونیک تخصصی، یکی از حلقه‌های اصلی رشد صنعت زیبایی ایران در تکمیل چرخه تولید تا مصرف است.',
            item3: '«خانومی» امروز به دنبال  رویای خود برای ایجاد پلتفرمی جامع برای زنان ایران است. «خانومی» بر اساس شناخت عمیقی که از فعالیت ۱۰ ساله در یک فروشگاه اینترنتی تخصصی به دست آورده، می‌خواهد با توسعه محصولات متنوع و افزودن سرویس‌های مختلف با محوریت نیازهای خاص زنان، فرصت تجربه کامل و منحصر‌به‌فردی را فراهم کند تا هر زنی رنگ خودش را به زندگی و مسیر پیش‌رویش بزند.',
            item4: '«خانومی» امروز تلاش می‌کند در کنار زنان ایرانی به ساختن دنیایی کمک کند که هر زنی خودش را همان‌طور که هست، دوست داشته باشد و با تقویت خودباوری و توانمندی‌هایش، از زیبایی، سلامت و زندگی امروز و فردایش مراقبت کند. به‌خاطر همین شعار همیشگی «خانومی» این است: زیبا و سرزنده باش به‌خاطر خودت!',
        },
        progress: {
            title: 'مسیر رشد خانومی',
            item1: {
                year: '1393',
                name: 'تولد خانومی',
            },
            item2: {
                year: '1393',
                name: 'شروع فعالیت در اینستاگرام',
            },
            item3: {
                year: '1393',
                name: 'راه اندازی سایت خانومی',
            },
            item4: {
                year: '1394',
                name: 'ثبت برند خانومی',
            },
            item5: {
                year: '1396',
                name: 'همکاری با اینفلوئنسرها',
            },
            item6: {
                year: '1397',
                name: 'جهش با تولید محتوای کاربرمحور',
            },
            item7: {
                year: '1398',
                name: 'جذب سرمایه',
            },
            item8: {
                year: '1399',
                name: 'افتتاح اولین مرکز پردازش مکانیزه سفارشات',
            },
            item9: {
                year: '1400',
                name: 'توسعه زیرساخت‌ها',
            },
            item10: {
                year: '1401',
                name: 'اولین حضور در فضای آفلاین',
            },
            item11: {
                year: '1402',
                name: 'افزایش ۳ برابری فروش',
            },
            item12: {
                year: '1403',
                name: 'راه‌اندازی بیزینس‌لاین‌های جدید',
            },
            item13: {
                year: '1404',
                name: 'راه‌اندازی سرویس‌های مالی ویژه زنان',
            },
        },
        statistics: {
            title: 'آمار و ارقام خانومی',
            ecommerce: {
                title: 'تجارت الکترونیک',
                item1: {
                    title: 'بیش از ۳ میلیون نفر',
                    text: 'تعداد بازدیدکنندگان یکتای سایت خانومی',
                },
                item2: {
                    title: 'نزدیک به ۲ میلیون نفر',
                    text: 'تعداد کل مشتریان',
                },
                item3: {
                    title: '۵۵٫۹۵%',
                    text: 'سهم فروش محصولات زیبایی در سایر شهرها',
                },
                item4: {
                    title: '۴۴٫۰۵%',
                    text: 'سهم فروش محصولات زیبایی در تهران',
                },
            },
            human: {
                title: 'نیروی انسانی',
                item1: {
                    title: '۳۴۱ نفر',
                    text: 'تعداد پرسنل خانومی',
                },
                item2: {
                    title: '۲۰ نفر',
                    text: 'تعداد مدیران زن',
                },
            },
            processing: {
                title: 'مرکز پردازش',
                item1: {
                    title: '۱۴٬۰۰۰ متر مربع',
                    text: 'مساحت مرکز پردازش',
                },
                item2: {
                    title: '۱۲۰٬۰۰۰ کالا',
                    text: 'ظرفیت روزانه پردازش کالا',
                },
                item3: {
                    title: '۲۰٬۰۰۰ سفارش',
                    text: 'ظرفیت روزانه پردازش سفارش',
                },
                item4: {
                    title: '۲٬۰۰۰٬۰۰۰ کالا',
                    text: 'ظرفیت انبار مرکز پردازش',
                },
            },
            social: {
                title: 'شبکه‌های اجتماعی',
                item1: {
                    title: 'بیش از ۱٫۴ میلیون نفر',
                    text: 'تعداد فالوورهای خانومی در اینستاگرام',
                },
                item2: {
                    title: '۹۲٪',
                    text: 'فالوور خانم',
                },
                item3: {
                    title: '۸٪',
                    text: 'فالوور آقا',
                },
            },
            team: {
                title: 'تیم فنی و محصول',
                body: {
                    title: 'بیش از ۵۰ نفر',
                    text: 'تعداد نیروهای تیم فنی و محصول اختصاصی خانومی',
                    description:
                        'خانومی با حضور بیش از ۵۰ متخصص، تیم فنی و محصول خود را برای توسعه زیرساخت‌های فنی دارد. خانومی با کمک این تیم متخصص در سال ۱۴۰۳ بستر تکنولوژی اختصاصی خود را به نام ناتیلوس راه‌اندازی کرد. خانومی با این بستر آماده ورود به استراتژی عرضه مستقیم تولیدکننده یا صاحب برند به مشتری است. این زیرساخت شامل سرویس‌های اصلی: این‌باند تخصصی، مدیریت انبار و سفارش‌های در راه، قیمت‌گذاری، پروموشن، مدیریت سفارشات و مدیریت ارسال است. «ناتیلوس» نام این زیرساخت برگرفته از نام صدفی است که ساختار آن بر پایه دنباله فیبوناچی شکل گرفته است که هر بند، مجموع تمام بندهای پیش از خود است و هر گام بزرگ تر از تمام گام های پیشین. الگویی الهام بخش شبیه آنچه در مسیر ۱۰ساله رشد خانومی رقم خورده است',
                },
            },
        },
        groups: {
            title: 'معرفی گروه خانومی',
            shop: {
                title: 'خانومی‌شاپ',
                text: 'اولین و جامع‌ترین فروشگاه اینترنتی تخصصی محصولات زیبایی در ایران که <span>سال ۱۳۹۳</span> راه‌اندازی شده است و در پنج ورتیکال بیوتی، سلامت، عطر، لوازم برقی شخصی و اکسسوری محصولات بیش از <span>۱۰۰۰ برند</span> معتبر را عرضه می‌کند. خانومی شاپ با تنوعی بالغ بر <span>۵۰ هزار کالای زیبایی و مراقبت</span> از خود، امکان انتخاب بهترین محصولات از مجموعه‌ی کاملی از برترین برندها را فراهم کرده است.',
            },
            bazar: {
                title: 'خانومی‌بازار',
                text: 'خانومی در <span>سال ۱۴۰۳</span> با هدف تکمیل زنجیره تأمین، <span>سرویس B2B «خانومی بازار»</span> را به عنوان واسطی بین تامین‌کننده و تولیدکننده راه‌اندازی کرد که خرده‌فروش‌ها در آن می‌توانند برای محصولات موردنیازشان سفارش بگذارند و تأمین‌کنندگان هم <span>بدون واسطه</span> به فروش عمده تولیدات خود بپردازند.',
            },
            finance: {
                title: 'خانومی‌فایننس',
                text: 'خانومی به‌عنوان بزرگ‌ترین بازار حوزه زنان ایران با <span>بیش از ۳ میلیون کاربر</span> و نزدیک به <span>دو میلیون مشتری</span> که بیش از <span>۹۰ درصد</span> آن‌ها را <span>زنان</span> تشکیل می‌دهند، در <span>سال ۱۴۰۴</span> سرویس‌های <span>سرمایه‌گذاری و پرداخت و بیمه</span> ویژه زنان را راه‌اندازی کرده است.',
            },
            business: {
                title: 'خانومی‌بیزینس',
                text: 'خانومی بیزینس، <span>رسانه‌ی متخصصان صنعت زیبایی ایران</span> است که در <span>سال ۱۴۰۲</span> راه‌اندازی شد؛ رسانه‌ای تخصصی برای آگاهی از تازه‌ترین تحولات <span>صنعت زیبایی در ایران</span> و جهان. خانومی بیزینس با رصد و بررسی روندها، نوآوری‌ها و چشم‌اندازهای این حوزه، تصویری به‌روز و دقیق از امروز و فردای صنعت زیبایی ایران و جهان به فعالان این حوزه می‌دهد.',
            },
            label: {
                title: 'پرایوت‌لیبل',
                text: 'خانومی به‌عنوان یکی از حلقه‌های <span>زنجیره تولید تا مصرف صنعت زیبایی</span> ایران در سال ۱۴۰۳ بیزینس‌لاینی را برای <span>توسعه برندهای جدید محصولات زیبایی</span> با مشارکت کارخانه‌های تولیدکننده،راه‌اندازی کرده است.',
            },
            ads: {
                title: 'بیوتی‌ادز',
                text: 'بیوتی‌ادز، <span>آژانس تخصصی تبلیغات صنعت زیبایی</span> است که در سال ۱۴۰۲ از سوی خانومی راه‌اندازی شد. بیوتی ادز با ارائه <span>پیشنهادهای ویژه به هر برند</span>، متناسب با دسته‌بندی محصولات‌شان، شرایط را برای <span>توسعه و رونمایی برندهای جدید</span> در کمپین‌های خود مهیا می‌کند.',
            },
        },
        responsibility: {
            title: 'مسئولیت‌های اجتماعی خانومی',
            description:
                'خانومی به عنوان بازار تخصصی زنان ایران، خود را موظف می‌داند تا از خودباوری، توانمندسازی و تلاش آن‌ها برای برداشتن قدم‌هایی رو به جلو حمایت کند.',
            item1: 'کمپین «تفاوت تو، رنگ زیبایی تو»',
            item2: 'کمپین «روز جهانی زن»',
            item3: 'کمپین «زنان در آینه»',
            item4: 'دختران ایران‌ خانوم',
            item5: 'انتشار ویدیوهای آگاهی‌بخش درباره زنان',
            item6: 'انتشار کتاب‌های زیبایی',
            item7: 'انتشار کتاب صوتی زنان نامرئی',
            item8: 'انتشار گاه‌شمار خودمراقبتی «خانومی»',
        },
        values: {
            title: 'ارزش های برند خانومی',
            respect: {
                title: 'احترام',
                text: 'رفتار و کلام ما با مخاطب مبتنی بر احترام است. ما به نیاز، انتخاب و درخواست مخاطبان در تمامی سطوح احترام می‌گذاریم.',
            },
            honesty: {
                title: 'صداقت و شفافیت',
                text: 'رفتار و کلام ما با مخاطبان هم از نظر محتوا و هم از نظر شیوه‌ی اجرا و بیان، صادقانه و شفاف است.',
            },
            responsibility: {
                title: 'مسئولیت‌پذیری و تعهد',
                text: 'رفتار و کلام ما در نقطه تماس با مخاطبان (در راستای کمک به آن‌ها) مسئولانه و قابل اجرا است.',
            },
            expert: {
                title: 'تخصص',
                text: 'ما تلاش می‌کنیم با ارائه سرویس‌های ویژه در بازار مرتبط با زنان و تولید محتوای تخصصی، متخصص بازار حوزه زنان باشیم.',
            },
        },
        video: 'نگاهی بر مرکز پردازش خانومی',
        gallery: 'گالری عکس‌های خانومی',
        awards: {
            title: 'جوایز و افتخارات خانومی',
            item1: 'دریافت لوح زرین دومین همایش ملی ساخت ایران در سال 1402',
            item2: 'دریافت نشان برتر برند محبوب مصرف‌کنندگان در دسته‌بندی فروشگاه‌های آنلاین زیبایی در 4 دوره',
            item3: 'برند برتر کارفرمایی در ششمین نمایشگاه کار ایران در سال 1402',
            item4: 'دریافت تقدیرنامه در دومین همایش پرایوت لیبل در سال 1403',
        },
    },
    en: {
        general: {
            showMore: 'Show more',
            showLess: 'Show less',
        },
        story: {
            title: 'The Story of Khanoumi',
            item1: 'Khanoumi — with over 3 million users, nearly 2 million of whom have made at least one purchase, and 1.5 million social media followers — is no longer just Iran’s first and largest specialized online beauty store. It is now the largest online business operating in the women’s market, moving steadily toward the vision of becoming Iran’s largest specialized marketplace for women’s services and products.',
            item2: 'Khanoumi, offering over 50,000 diverse products from more than 1,000 reputable brands, is not only one of the primary resources for Iranian women seeking self-care products but also a major contributor to the growth of Iran’s beauty industry, completing the cycle from production to consumption with a focus on specialized e-commerce development.',
            item3: 'Today, Khanoumi is fulfilling its dream of creating a comprehensive platform for Iranian women. Drawing on a decade of experience operating a specialized online store, Khanoumi aims to expand its range of products and introduce various services tailored to women’s unique needs, creating a complete and personalized experience where every woman can color her life and her future in her own unique way.',
            item4: 'Khanoumi strives to help build a world alongside Iranian women — a world where every woman loves herself as she is, strengthens her self-belief and capabilities, and cares for her beauty, health, and future. That’s why Khanoumi’s timeless slogan is:  "Be Beautiful and Vibrant for Yourself!"',
        },
        progress: {
            title: "Khanoumi's Growth Journey",
            item1: {
                year: '2014',
                name: 'Khanoumi founded',
            },
            item2: {
                year: '2014',
                name: 'Instagram activity began',
            },
            item3: {
                year: '2014',
                name: 'Khanoumi website launched',
            },
            item4: {
                year: '2015',
                name: 'Khanoumi brand registered',
            },
            item5: {
                year: '2017',
                name: 'Started influencer collaborations',
            },
            item6: {
                year: '2018',
                name: 'UGC (User-Generated Content) boom',
            },
            item7: {
                year: '2019',
                name: 'Raised investor funding',
            },
            item8: {
                year: '2020',
                name: 'Opened the first mechanized order fulfillment center',
            },
            item9: {
                year: '2021',
                name: 'Scaled infrastructure',
            },
            item10: {
                year: '2022',
                name: 'Entered offline retail for the first time',
            },
            item11: {
                year: '2023',
                name: 'Tripled sales',
            },
            item12: {
                year: '2024',
                name: 'Launched new business lines',
            },
            item13: {
                year: '2025',
                name: 'Introduced specialized financial services for women',
            },
        },
        statistics: {
            title: 'Khanoumi in Numbers',
            ecommerce: {
                title: 'E-commerce',
                item1: {
                    title: 'Over 3 million',
                    text: 'unique website visitors',
                },
                item2: {
                    title: 'Nearly 2 million',
                    text: 'total customers',
                },
                item3: {
                    title: '44.05%',
                    text: 'of beauty sales from Tehran',
                },
                item4: {
                    title: '55.95%',
                    text: 'of beauty sales from other cities',
                },
            },
            human: {
                title: 'Human Resources',
                item1: {
                    title: '341',
                    text: 'total employees',
                },
                item2: {
                    title: '20',
                    text: 'female managers',
                },
            },
            processing: {
                title: 'Fulfillment Center',
                item1: {
                    title: '14,000 square meters',
                    text: 'warehouse space',
                },
                item2: {
                    title: '120,000 products daily',
                    text: 'capacity to process',
                },
                item3: {
                    title: '20,000 orders daily',
                    text: 'capacity to process',
                },
                item4: {
                    title: '2 million products',
                    text: 'storage capacity',
                },
            },
            social: {
                title: 'Social Media',
                item1: {
                    title: 'Over 1.4 million',
                    text: 'Instagram followers',
                },
                item2: {
                    title: '92%',
                    text: 'female followers',
                },
                item3: {
                    title: '8%',
                    text: 'male followers',
                },
            },
            team: {
                title: 'Technical and Product Team',
                body: {
                    title: 'Over 50',
                    text: 'technical and product specialists',
                    description:
                        "In 2024, Khanoumi launched its proprietary technology platform, Nautilus. Nautilus enables direct-to-customer operations for manufacturers and brands through services such as specialized inbound logistics, inventory and in-transit management, pricing, promotions, order management, and shipping. The name Nautilus was inspired by the Fibonacci-sequenced structure of the nautilus shell, symbolizing continuous and expanding growth — a reflection of Khanoumi's 10-year journey.",
                },
            },
        },
        groups: {
            title: 'Introducing Khanoumi Group',
            shop: {
                title: 'Khanoumi Shop',
                text: 'Launched in <span>2014</span>, Khanoumi Shop is Iran’s first and most comprehensive specialized online store for beauty products. It operates across five verticals: beauty, health, fragrance, personal electronics, and accessories — offering products from over <span>1,000 reputable brands</span>. With a collection of over <span>50,000 beauty and self-care items</span>, Khanoumi Shop provides a complete selection of top brands for customers.',
            },
            bazar: {
                title: 'Khanoumi Bazaar',
                text: 'In <span>2024</span>, aiming to complete the supply chain, Khanoumi launched its <span>business-to-business service</span> "Khanoumi Bazaar," serving as a bridge <span>between suppliers and retailers</span>. Retailers can order their required products, and suppliers can sell their productions wholesale without intermediaries.',
            },
            finance: {
                title: 'Khanoumi Finance',
                text: 'As Iran’s largest women-focused marketplace with over 3 million users and around <span>2 million customers -- 90% of whom are women</span> -- Khanoumi launched investment, payment, and insurance services specifically for women in <span>2025</span>.',
            },
            business: {
                title: 'Khanoumi Business',
                text: "Launched in <span>2023</span>, Khanoumi Business is the <span>specialized media outlet</span> for <span>Iran's beauty industry</span>, offering up-to-date insights on industry trends, innovations, and forecasts both in Iran and globally, providing professionals with a clear and updated view of the beauty sector’s present and future.",
            },
            label: {
                title: 'Private Label',
                text: 'In 2024, Khanoumi introduced a new business line focused on developing private label beauty brands in collaboration with manufacturers, as part of completing the production-to-consumption chain in Iran’s beauty industry.',
            },
            ads: {
                title: 'Beauty Ads',
                text: 'In 2024, Khanoumi introduced a new business line focused on developing private label beauty brands in collaboration with manufacturers, as part of completing the production-to-consumption chain in Iran’s beauty industry.',
            },
        },
        responsibility: {
            title: 'Khanoumi’s Social Responsibility',
            description:
                "As Iran’s specialized women’s marketplace, Khanoumi is committed to supporting women's self-belief, empowerment, and progress:",
            item1: '"Your Difference, Your Beauty" campaign',
            item2: '"International Women’s Day" campaign',
            item3: '"Women in the Mirror" campaign',
            item4: '“Daughters of Iran” campaign',
            item5: 'Publishing educational videos about women’s issues',
            item6: 'Publishing beauty-related books',
            item7: 'Publishing the audiobook *Invisible Women*',
            item8: 'Publishing Khanoumi’s Self-Care Calendar',
        },
        values: {
            title: 'Khanoumi Brand Values',
            respect: {
                title: 'Respect',
                text: 'Our behavior and communication with customers are rooted in respect. We value customer needs, choices, and requests at every level.',
            },
            honesty: {
                title: 'Honesty and Transparency',
                text: 'We engage honestly and transparently with our customers in both content and delivery.',
            },
            responsibility: {
                title: 'Responsibility and Commitment',
                text: 'We act responsibly and ensure effective communication in all interactions with our audience.',
            },
            expert: {
                title: 'Expertise',
                text: "We aim to specialize in the women's market by offering tailored services and expert content creation.",
            },
        },
        video: 'A Look Inside Khanoumi’s Fulfillment Center',
        gallery: 'Khanoumi Photos',
        awards: {
            title: 'Awards and Recognitions',
            item1: 'Awarded "Top Favorite Consumer Brand" in the online beauty stores category for four consecutive years',
            item2: 'Received the Golden Plaque at the 2nd National "Made in Iran" Conference (2023)',
            item3: 'Named "Top Employer Brand" at the 6th Iran Job Fair (2023)',
            item4: 'Received a Certificate of Appreciation at the 2nd Private Label Conference (2024)',
        },
    },
}
